import { render, staticRenderFns } from "./commodity-rank.vue?vue&type=template&id=b9cc61cc&scoped=true&"
import script from "./commodity-rank.vue?vue&type=script&lang=js&"
export * from "./commodity-rank.vue?vue&type=script&lang=js&"
import style0 from "./commodity-rank.vue?vue&type=style&index=0&id=b9cc61cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9cc61cc",
  null
  
)

export default component.exports